module.exports = "/static/assets/90f5c01996c6a9142745d3845ab4eb9c.png";